import React, { Component } from "react";
import { CSVLink } from "react-csv";

class AdminAnalytics extends Component {
  componentDidMount() {
    this.props.adminRequestFullAnalytics();
  }

  getRows() {
    return this.props.fullAnalytics || [];
  }

  getLabel(row) {
    if (row.EventType === "search") {
      return row.Data || "-";
    }

    return row.MotifName || row.MotifId || "-";
  }

  getDate(row) {
    return row.LastSeen || row.CreatedAt;
  }

  render() {
    const rows = this.getRows();
    const headers = [
      { label: "Event Type", key: "EventType" },
      { label: "Motif / Search Term", key: "Label" },
      { label: "Motif Name", key: "MotifName" },
      { label: "Motif ID", key: "MotifId" },
      { label: "Data", key: "Data" },
      { label: "Count", key: "Count" },
      { label: "Last Seen", key: "LastSeen" },
    ];

    const exportRows = rows.map(row => ({
      ...row,
      Label: this.getLabel(row),
    }));

    return (
      <div id="admin-analytics">
        <div className="admin-analytics-toolbar">
          <p>{rows.length} grouped analytics results</p>
          {rows.length > 0 ? (
            <CSVLink
              className="btn"
              data={exportRows}
              headers={headers}
              filename="lifebelt-analytics-summary.csv"
            >
              Download CSV
            </CSVLink>
          ) : null}
        </div>

        <table className="submitted-belt-list">
          <thead>
            <tr>
              <th>Event Type</th>
              <th>Motif / Search Term</th>
              <th>Count</th>
              <th>Last Seen</th>
            </tr>
          </thead>

          <tbody>
            {rows.slice(0, 500).map((row, i) => {
              const date = this.getDate(row);

              return (
                <tr key={"analytics-" + i}>
                  <td style={{ fontWeight: "bold" }}>{row.EventType}</td>
                  <td>{this.getLabel(row)}</td>
                  <td>{row.Count}</td>
                  <td>{date ? new Date(date).toLocaleString("en-US") : "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AdminAnalytics;
